export default "__VITE_ASSET__C0z6mJTH__"